import React from 'react';
import { useState } from 'react';
import { ImageProps, ImageStyle, ImageURISource, View } from 'react-native';
import { KImage } from '@/component/RtlLayout';
import shoppingBag from '@/assets/images/shoppping-bag.png';

interface IProps {
    backgroundSource?: ImageURISource;
    backgroundImageStyle?: ImageStyle;
    source: ImageURISource;
    style?: ImageStyle;
    resizeMode?: string;
    cropOption?: {
        ratio?: number;
    };
    kWaiFirstImage?: boolean;
}

enum ImageState {
    'LoadingStart',
    'Loading',
    'Success',
    'Error',
}

export const ImageWithBackground = React.forwardRef((props: React.PropsWithChildren<IProps & ImageProps>, ref) => {
    const {
        backgroundSource = shoppingBag,
        backgroundImageStyle,
        source,
        style = {},
        resizeMode,
        resizeMethod,
        onLoadStart,
        onLoadEnd,
        kWaiFirstImage,
        ...restProps
    } = props;
    const [loadStatus, setLoadStatus] = useState<ImageState>(ImageState.Loading);
    useState(() => {
        onLoadStart?.();
    });
    const handleImageLoaded = err => {
        setLoadStatus(ImageState.Success);
        if (props.onLoad) props.onLoad(err);
    };
    const handleError = err => {
        setLoadStatus(ImageState.Error);
        if (props.onError) props.onError(err);
    };

    const renderPending = () => {
        return (
            <KImage
                style={[
                    {
                        position: 'absolute',
                    },
                    style,
                    backgroundImageStyle,
                ]}
                source={backgroundSource}
            />
        );
    };

    const renderError = () => {
        return (
            <KImage
                style={[
                    {
                        position: 'absolute',
                    },
                    style,
                    backgroundImageStyle,
                ]}
                source={backgroundSource}
            />
        );
    };

    return (
        <View style={[{ position: 'relative' }, style]} {...restProps}>
            {loadStatus === ImageState.Loading ? renderPending() : null}
            {loadStatus === ImageState.Error ? renderError() : null}
            <KImage
                source={source}
                onLoadEnd={onLoadEnd}
                onLoad={handleImageLoaded}
                onError={handleError}
                style={[
                    style,
                    // {
                    //     display: loadStatus === ImageState.Success ? 'flex' : 'none',
                    // },
                ]}
                kWaiFirstImage={kWaiFirstImage}
                resizeMode={resizeMode}
                resizeMethod={resizeMethod}
            />
        </View>
    );
});
